import { z } from 'my-zod'
import { assetFamilyView } from '../../fleet-operations/asset-family'

export const assetFamilyAvailabilitySystemView = assetFamilyView
  .omit({
    deletedDate: true
  })
  .augment({
    availableQuantity: z.number()
  })

export type assetFamilyAvailabilitySystemView = z.infer<typeof assetFamilyAvailabilitySystemView>
